import type { TFunction } from 'i18next';

/**
 * What a new file costs. It has coordinates of its own, so what is drawn on the old one
 * goes back to being drawn, and the original kept from before the first edit goes with
 * them. Asked when there is something to lose, and only then.
 */
export function confirmModelReplaced(
  place: { model_3d_lines_count?: number | null; model_3d_has_original?: boolean },
  t: TFunction,
) {
  const count = place.model_3d_lines_count ?? 0;
  if (count === 0 && !place.model_3d_has_original) return true;

  const warnings = place.model_3d_has_original ? [t('cragModel.current.originalLost')] : [];
  warnings.push(count > 0 ? t('cragModel.current.linesLost', { count }) : t('cragModel.current.goOn'));
  return window.confirm(warnings.join('\n\n'));
}
